// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-2768f3a6]{display:none}.show-on-mobile-only[data-v-2768f3a6]{display:contents}@media(min-width:768px){.show-on-mobile-only[data-v-2768f3a6]{display:none}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
